import { trackEvent } from '~/lib/analytics';

export default {
  namespaced: true,
  state: {},
  actions: {
    trackEvent({ _ }, action) {
      const params = action.analytics;

      if (action.headers && (action.headers['is-first-invoice'] === 'true')) {
        Object.assign(params, { value: 1 });
      }
      trackEvent(params);
    },
  },
};
